import React, { createContext, useState, ReactNode, useContext, useCallback } from 'react';

import { Brand } from '@models/Brand';
import * as BrandService from '@services/brand';
import { IBrandForm } from '@pages/BrandPage/models/IBrandForm';

interface BrandState {
  brands: Brand[];
  loadRequestBrand: Function;
  createBrand: Function;
  updateBrand: Function;
  loading: boolean;
}

interface BrandProviderProps {
  children: ReactNode;
}

export const BrandContext = createContext<BrandState>(Object.assign({}));

const BrandProvider: React.FC<BrandProviderProps> = ({ children }) => {
  const [brands, setBrands] = useState<Brand[]>([]);
  const [loading, setLoading] = useState<boolean>(false);

  const loadRequestBrand = useCallback(
    async (status: boolean, search = '') => {
      setLoading(true);
      const { data: brands } = await BrandService.get(status, search);
      setLoading(false);
      setBrands(brands);
    },
    [brands],
  );

  const createBrand = useCallback(
    async (brand: IBrandForm) => {
      setLoading(true);
      try {
        const { data: newBrand } = await BrandService.save(brand);
        if (brands.length == 0) {
          setBrands([newBrand]);
        } else {
          setBrands(brands.concat(newBrand));
        }
      } catch (error) {
        console.log('error no brand context', error);
      }
      setLoading(false);
    },
    [brands],
  );

  const updateBrand = useCallback(
    async (brand: IBrandForm) => {
      setLoading(true);
      const { data: updatedBrand } = await BrandService.update(brand);
      if (brands.length != 0) {
        setBrands(
          brands.map((element) => {
            if (element.brandId == updatedBrand.brandId) {
              return updatedBrand;
            }
            return element;
          }),
        );
      } else {
        setBrands([updatedBrand]);
      }
      setLoading(false);
    },
    [brands],
  );

  return (
    <BrandContext.Provider
      value={{
        brands,
        loading,
        loadRequestBrand,
        createBrand,
        updateBrand,
      }}
    >
      {children}
    </BrandContext.Provider>
  );
};

const useBrand = () => {
  return useContext(BrandContext);
};

export { BrandProvider, useBrand };
